import axios from "axios";
import getHeaders from "../../constants/headers";
import { PRICElIST_BASE_URL } from "../BaseURL";

export const addGarmentPack =  (brandId, data) => {
    return axios({
      method: 'post',
      url:
        PRICElIST_BASE_URL + '/api/secure/v2/brand/' + brandId + '/garment-pack',
      // for android use
      headers:  getHeaders(),
      data: JSON.stringify(data),
    });
  };
  
  export const updateGarmentPack =  (brandId, data) => {
    return axios({
      method: 'put',
      url:
        PRICElIST_BASE_URL + '/api/secure/v2/brand/' + brandId + '/garment-pack',
      // for android use
      headers:  getHeaders(),
      data: JSON.stringify(data),
    });
  };